<template>
  <div ref="chatMessagesContainer" class="chat-messages-container">
    <div
      v-if="emptyPlaceholder.length > 0 && chatMessages.length === 0"
      v-html="emptyPlaceholder"
      class="text-text-light --text-sm text-center q-mt-md"
    />

    <transition-group appear name="fade" mode="out-in">
      <q-list
        v-for="(chatMessage, i) in chatMessages"
        :key="i + '_chatMessage'"
        class="chat-messages full-width"
        padding
      >
        <q-card
          class="q-mx-md bg-background q-py-xs"
          flat
          :class="
            chatMessage.fromUser
              ? 'bg-background-light'
              : 'bg-background --shadow__bottom'
          "
        >
          <q-item
            :style="[chatMessage.fromUser ? { 'text-align': 'right' } : {}]"
          >
            <q-item-section>
              <div
                class="--text-sm text-text-light flex items-center text-weight-medium q-mb-xs"
                :class="chatMessage.fromUser ? 'justify-end' : 'justify-start'"
              >
                <q-icon
                  v-if="!chatMessage.fromUser"
                  name="sym_r_auto_awesome"
                  size="12px"
                  class="q-mr-xs"
                  color="secondary"
                />
                {{ chatMessage.fromUser ? "You" : $store.state.brand.name }}
              </div>
              <div
                v-html="chatMessage.message"
                :class="chatMessage.fromUser ? 'text-weight-medium' : ''"
              />
            </q-item-section>
          </q-item>

          <div
            v-if="
              'dropdownContent' in chatMessage &&
                chatMessage.dropdownContent.length > 0
            "
            class="q-pa-sm"
          >
            <div
              class="flex items-center justify-center text-text-light cursor-pointer --hover-lighten"
              @click="
                () => {
                  toggleChatMessageDropdown(i);
                }
              "
            >
              <div class="--text-xs text-weight-medium">
                {{ messagesActiveDropdown.includes(i) ? "Hide" : "Show" }}
                {{ dropdownTitleDescriptor }}
              </div>
              <q-icon
                :name="
                  messagesActiveDropdown.includes(i)
                    ? 'sym_r_keyboard_arrow_up'
                    : 'sym_r_keyboard_arrow_down'
                "
                size="17px"
                style="margin-left: 1px"
              />
            </div>
            <div
              v-show="messagesActiveDropdown.includes(i)"
              v-html="chatMessage.dropdownContent"
              class="q-pa-sm"
            />
          </div>
        </q-card>
      </q-list>
    </transition-group>

    <div v-if="receivingMessage" class="chat-message text-center q-mt-md">
      <q-spinner-dots
        size="3rem"
        color="grey-7"
        style="margin: 0 auto"
      ></q-spinner-dots>
    </div>

    <slot name="below-messages" />
  </div>
</template>

<script>
export default {
  name: "ChatMessages",
  props: {
    chatMessages: {
      type: Array,
      required: true
    },
    receivingMessage: {
      type: Boolean,
      default: false
    },
    emptyPlaceholder: {
      type: String,
      default: ""
    },
    dropdownTitleDescriptor: {
      type: String,
      default: "More"
    },
    suggestedResponses: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      messagesActiveDropdown: []
    };
  },
  watch: {
    chatMessages: {
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom();
          }, 100);
        });
        this.messagesActiveDropdown = [];
      },
      deep: true
    },
    receivingMessage(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom();
          }, 100);
        });
      }
    }
  },
  computed: {},
  mounted() {
    this.scrollToBottom();
  },
  methods: {
    scrollToBottom() {
      const container = this.$refs.chatMessagesContainer;
      if (!container) return;

      // Scroll the container itself
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth"
      });

      // Scroll direct parent element
      const parent = container.parentElement;
      if (parent) {
        parent.scrollTo({
          top: parent.scrollHeight,
          behavior: "smooth"
        });
      }
    },
    toggleChatMessageDropdown(messageIndex) {
      if (this.messagesActiveDropdown.includes(messageIndex)) {
        this.messagesActiveDropdown.splice(
          this.messagesActiveDropdown.indexOf(messageIndex),
          1
        );
      } else {
        this.messagesActiveDropdown.push(messageIndex);
      }
      setTimeout(() => {
        this.scrollToBottom();
      }, 10);
    }
  }
};
</script>

<style scoped lang="scss">
.chat-messages-container {
  overflow-y: auto;
  width: 100%;
  padding-bottom: $space-xs;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
